import React from 'react';
import { Grid, Container, GridProps } from '@mui/material';
type Props = {
  gridProps?: GridProps;
  children: React.ReactElement[];
  className?: string;
};

export const LessonPlannerGridLayout: any = ({ children, gridProps, ...props }: Props) => {
  return (
    <Container {...props} maxWidth="xl">
      <Grid item {...gridProps}>
        <Grid
          container
          spacing={5}
          style={{ margin: 0, display: 'flex', justifyContent: 'center' }}
        >
          {children}
        </Grid>
      </Grid>
    </Container>
  );
};
